import React, { useState, useEffect } from 'react'
import { FaPlus, FaCheckCircle, FaTrash } from 'react-icons/fa'
import { Box, Stack, SimpleModal, Button, Input, Text, Heading, ConfirmButton, Icon } from '@/components/lib'
import api from '../../api'
import utils from '@/utils/utils'
import useStore from '@/store'

const colours = ['#f5b7b1', '#d7bde2', '#a9cce3', '#a3e4d7', '#a9dfbf', '#f9e79f', '#f5cba7']

export default function DataTypeTagCreator ({ trigger, dataTypeTag }) {
  const [open, setOpen] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [name, setName] = useState('')
  const [colour, setColour] = useState('#f5b7b1')
  const { trial, addDataTypeTag, deleteDataTypeTag } = useStore()

  useEffect(() => {
    setName(dataTypeTag?.name ?? '')
    setColour(dataTypeTag?.colour ?? '#f5b7b1')
    setIsEditing(!!dataTypeTag)
  }, [dataTypeTag])

  function create () {
    if (!name || !colour) return
    const data = { name, colour }
    if (isEditing) {
      api.dataTypeTags.update(dataTypeTag._id, data, newTag => {
        utils.toast('success', 'Tag saved')
        addDataTypeTag(newTag)
        setOpen(false)
      }, err => utils.toast('error', 'Unable to save tag', err.message))
    } else {
      api.dataTypeTags.create(trial._id, data, newTag => {
        utils.toast('success', 'Tag created')
        addDataTypeTag(newTag)
        setOpen(false)
      }, err => utils.toast('error', 'Unable to create tag', err.message))
    }
  }

  function deleteTag (id) {
    api.dataTypeTags.delete(id, () => {
      utils.toast('info', 'Tag deleted')
      deleteDataTypeTag(id)
      setOpen(false)
    }, err => utils.toast('error', 'Unable to delete tag', err.message))
  }

  return (
    <>
      {trigger
        ? React.cloneElement(trigger, { onClick: () => setOpen(true) })
        : <Button colorPalette='blue' onClick={() => setOpen(true)}><Icon as={FaPlus} mr={2} /> Create a data tpe tag</Button>}
      <SimpleModal
        isOpen={open} onClose={() => setOpen(false)} modalProps={{ size: 'lg' }}
        header={isEditing ? 'Update data type tag' : 'Create a data type tag'}
        body={
          <Stack spacing={5}>
            <Stack>
              <Heading size='sm'>Tag name</Heading>
              <Text fontSize='sm'>Choose a name for your data type tag.</Text>
              <Input bg='bg.surface' autoFocus type='text' placeholder='Tag name' value={name} onChange={e => setName(e.target.value)} />
            </Stack>

            <Stack>
              <Heading size='sm'>Colour</Heading>
              <Text fontSize='sm'>A colour scheme helps you to identify the tag.</Text>
              <Stack direction='row' gap={2}>
                {colours.map(c =>
                  <Box rounded='md' cursor='pointer' w={10} h={10} key={c} bg={c} position='relative' onClick={() => setColour(c)}>
                    {c === colour &&
                      <Icon as={FaCheckCircle} position='absolute' style={{ top: -5, right: -5 }} />}
                  </Box>
                )}
              </Stack>
            </Stack>
          </Stack>
}
        footer={
          <Stack direction='row' justify='space-between'>
            {isEditing &&
              <ConfirmButton
                trigger={<Button variant='ghost'><Icon><FaTrash /></Icon></Button>}
                header='Really delete this tag?'
                footer='Data types associated with this tag will not be deleted.'
                onConfirm={e => deleteTag(dataTypeTag?._id)}
              />}
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button colorPalette='primary' onClick={create}>{isEditing ? 'Save tag' : 'Add tag'}</Button>
          </Stack>
}
      />
    </>
  )
}
